import Navigation from "@/components/silentscan/Navigation";
import Hero from "@/components/silentscan/Hero";
import TryDemos from "@/components/silentscan/TryDemos";
import About from "@/components/silentscan/About";
import HowItWorks from "@/components/silentscan/HowItWorks";
import Features from "@/components/silentscan/Features";
import WhyChoose from "@/components/silentscan/WhyChoose";
import TrustSection from "@/components/silentscan/TrustSection";
import MentalSection from "@/components/silentscan/MentalSection";
import Vision from "@/components/silentscan/Vision";
import Manifesto from "@/components/silentscan/Manifesto";
import Demo from "@/components/silentscan/Demo";
import Testimonials from "@/components/silentscan/Testimonials";
import AboutLegal from "@/components/silentscan/AboutLegal";
import GamificationSection from "@/components/silentscan/GamificationSection";
import Faq from "@/components/silentscan/Faq";
import Footer from "@/components/silentscan/Footer";

export default function LandingPage() {
  return (
    <main data-testid="landing-page" className="relative">
      <Navigation />
      <Hero />
      <TryDemos />
      <About />
      <HowItWorks />
      <Features />
      <WhyChoose />
      <TrustSection />
      <MentalSection />
      <Manifesto />
      <Vision />
      <Demo />
      <GamificationSection />
      <Testimonials />
      <AboutLegal />
      <Faq />
      <Footer />
    </main>
  );
}
